import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import {AvlCurrentLocationGmapComponent} from './avl-current-location-gmap.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {default as pjson} from '../../../../../package.json';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatInputModule} from '@angular/material/input';

@NgModule({
  declarations: [
    AvlCurrentLocationGmapComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatSlideToggleModule,
    ComponentSetupModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
  ],
  exports: [
    AvlCurrentLocationGmapComponent
  ],
  providers: []
})

export class AvlCurrentLocationGmapModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(AvlCurrentLocationGmapComponent, 'sc-avl-current-location-gmap',
      this.injector, pjson.version);
  }
}
